import { Metadata, RpcError } from "grpc-web";
import { getCurrentLanguage } from "./Helpers";
import i18n from "./i18n";
import { AuthenticationEndpointClient } from "../repository/dimensions/AuthenticationServiceClientPb";
import { AuthenticateReply, RefreshTokenRequest } from "../repository/dimensions/authentication_pb";
import {
    HubConnection,
    HubConnectionBuilder,
    HubConnectionState,
    HttpTransportType,
} from "@microsoft/signalr";

export const ADVANCED_CHART_API_URL = "https://advancedchartingprod.wittybay-22530ea3.westeurope.azurecontainerapps.io";//"https://localhost:5101";
export const API_URL = "https://dimensionsclientsprod.bravemeadow-cbfe1e92.germanywestcentral.azurecontainerapps.io"//"http://192.168.8.100:5207";//"https://dimensionsclientportal.azurewebsites.net";//"https://localhost:5101";


const client = new AuthenticationEndpointClient(API_URL, null, null);

export interface ApiMessage {
    body: string,
    title: string,
    type: number,
    data: any,
}

export interface APIRequest<T> {
    body: T,
    headers?: {},
    metadata?: any,
}

export interface APIResponse<T> {
    metadata?: any,
    response: T,
}



export const toApiMessage = (res: any): ApiMessage => {
    let type = Number(res.type?.value)
    if (!Number.isNaN(type)) {
        return { body: decodeURIComponent(res.body?.value), title: decodeURIComponent(res.title?.value), type: type } as ApiMessage;
    } else {
        return { data: decodeURIComponent(res?.data ?? ""), body: decodeURIComponent(res.body), title: decodeURIComponent(res.title), type: Number(res.type) } as ApiMessage;
    }
}


export const getCurrentLng = () => {

    var lang = getCurrentLanguage();
    if (lang == 'ar')
        lang += "-LY"
    else
        lang += "-US"

    return lang;
};


export const getHeaders = () => {

    var auth: Record<string, any> = { "Accept-Language": getCurrentLng(), "Timezone": (((new Date()).getTimezoneOffset()) * -1) + "" };
    try {
        auth = {
            ...auth,
            "Authorization": 'Bearer ' + getSession().accesstoken?.token?.value,
        }
    } catch {

    }
    return auth;
};


export const refreshSession = async (): Promise<boolean> => {
    try {
        var session = getSession();
        if (session != null) {
            var req = new RefreshTokenRequest();
            req.setSessionid(Number(session.accesstoken?.sessionid))
            if (session.accesstoken?.refreshtoken) {
                req.setRefreshtoken(session.accesstoken?.refreshtoken?.value)
                var r = await client.refreshToken(req, getHeaders() ?? {});
                var response = r.toObject();
                //console.log(response);
                if (response?.authenticate) {
                    saveSession(response?.authenticate)
                    return true;
                }
            }
            return false;

        }
        return false;

    } catch (e) {
        if (e == null) {
            return false
        }
        let message = toApiMessage((e as RpcError).metadata);
        if (message.data) {
            return false;
        }
        throw e;
    }
}

let currentSession: any = localStorage.getItem('sessionDimansions');

export const saveSession = (session: AuthenticateReply.AsObject) => {
    currentSession = JSON.stringify(session)
    localStorage.setItem('sessionDimansions', currentSession)
};


export const getSession = (): AuthenticateReply.AsObject => {
    var i = currentSession;
    if (i) {
        var c = JSON.parse(i) as any;
        if (c.accesstoken) {
            return c;
        }
    }
    clearSession();
    throw null;
};
export const getUsername = (): string | undefined => {

    var i = currentSession;
    if (i) {
        var c = JSON.parse(i) as any;
        if (c.username?.value) {
            return c.username?.value;
        }
    }
    throw undefined;
};

export const isLoggedIn = (): boolean => {
    var i = currentSession;
    if (i) {
        var c = JSON.parse(i) as AuthenticateReply.AsObject;
        if (c.accesstoken) {
            return true;
        }
    }
    return false;
};

export const clearSession = () => {
    currentSession = undefined;
    localStorage.removeItem('sessionDimansions');

};






/** Module‑level variable that holds the single instance */
let feedConnection: any = null;

/**
 * Returns a started HubConnection.
 * If a connection already exists and is still connected, it is reused (singleton).
 * Otherwise a new connection is built and started.
 */
export const getFeedConnection = async (): Promise<HubConnection | null> => {
    // Re‑use the existing live connection

    if (
        feedConnection &&
        feedConnection.state === HubConnectionState.Connected
    ) {
        return feedConnection;
    }


    // Helper that actually builds & starts the connection
    const buildConnection = async (): Promise<HubConnection | null> => {
        try {
            const connection = new HubConnectionBuilder()
                .withUrl(`${ADVANCED_CHART_API_URL}/feed`, {
                    transport: HttpTransportType.WebSockets,
                    accessTokenFactory: () =>
                        getSession().accesstoken?.token?.value ?? "",
                })
                .withAutomaticReconnect()
                .build();

            await connection.start();

            return connection;
        } catch (err: any) {
            // Token expired? Try once after refreshing the session
            if (err.message?.includes("Status code '401'")) {
                const refreshed = await refreshSession();
                if (refreshed) {
                    return await buildConnection();
                }
            }
            return null;
            // Re‑throw so callers can handle/reject as they wish
        }
    };

    feedConnection = await buildConnection();

    return feedConnection;
};
export const terminateFeedConnection = async (): Promise<void> => {
    // Re‑use the existing live connection
    if (feedConnection == null || feedConnection == undefined) {
        return;
    }
    feedConnection.off()
    await feedConnection.stop();

    feedConnection = null;

    // Helper that actually builds & starts the connection


};

